import React, { useEffect } from 'react';
import { Route, Switch, Redirect, useLocation, useHistory } from 'react-router';
import { useDispatch, useSelector } from "react-redux";
// import jwt_decode from "jwt-decode";
import queryString from 'query-string';
import * as R from 'ramda';
import axios from 'axios';
import { fetchUser } from '../actions/account-api';

import '../assets/stylesheets/sbx.scss';

import Navbar from './_common/navbar';
import Account from './account';
import Services from './services';
// import { Facturation } from './facturation';
import { storageService } from '../constants/utils/storage';
import { getAuthenticationUrl } from '../constants/webapi/account';
import * as Loadings from '../constants/loadings/account';
import { URLParams } from '../constants/utils/urlParams';
import { LoadingBall } from './_common/loadingBall';


const App = () => {
    //#region  OLD VERSION
    // constructor(props) {
    //     super(props);

    //     let query = qs.parse(props.location.hash.substring(1));
    //     if (query.access_token !== undefined) {
    //         sessionStorage.removeItem("access_token");
    //         sessionStorage.setItem("access_token", query.access_token);
    //         axios.defaults.headers.common['Authorization'] = "Bearer " + query.access_token;
    //     } else {
    //         axios.defaults.headers.common['Authorization'] = "Bearer " + sessionStorage.getItem("access_token");
    //     }
    //     if (query.id_token !== undefined) {
    //         sessionStorage.removeItem("id_token");
    //         sessionStorage.setItem("id_token", query.id_token);
    //     }

    //     if (props.account.user === undefined) {
    //         let idToken = sessionStorage.getItem('id_token');
    //         props.fetchUser(idToken);
    //     }
    // }

    // render() {
    //     if (this.props.account.user === undefined) {
    //         return '';
    //     }

    //     let state = new URLSearchParams(this.props.location.search).get("state");
    //     if (R.isNil(state)) {
    //         let query = qs.parse(this.props.location.hash.substring(1));
    //         state = query.state;
    //     }
    //     if (!R.isNil(state)) {
    //         state = decodeURI(state);
    //         let stateParts = state.split("&");
    //         let returnUrlStatePart = stateParts.find(s => s.startsWith('return_url') > -1);
    //         if (!R.isNil(returnUrlStatePart)) {
    //             let returnUrl = returnUrlStatePart.split("=")[1];
    //             if (!R.isNil(returnUrl) && returnUrl !== '') {
    //                 if (returnUrl.includes('activation_token_id')) {
    //                     returnUrl = returnUrl.replace('-', '=');
    //                 }
    //                 // eslint-disable-next-line
    //                 returnUrl = returnUrl.replace(/(https?:)?\/\/[^\/]+/i, "");
    //                 return <Redirect to={returnUrl} />;
    //             }
    //         }
    //     }
    //#endregion
    const account = useSelector(state => state.account);
    const location = useLocation();
    const dispatch = useDispatch();
    const history = useHistory();

    useEffect(() => {
        async function init() {
            let query = queryString.parse(location.hash);
            const { idToken, accessToken } = storageService();
            axios.defaults.headers.common['Authorization'] = "Bearer " + accessToken;

            let state = new URLSearchParams(location.search).get("state");
            if (state === null || state === undefined) {
                state = query.state;
            }
            if (state !== undefined && state !== null && !state.startsWith('/')) {
                // await dispatch(ActivateAccount(state, idToken));
            }
            else {
                if (account.user === undefined) {
                    if (R.isNil(idToken)) {
                        window.location = getAuthenticationUrl();
                        return;
                    }
                    // const decoded = jwt_decode(idToken);
                    const user = await dispatch(fetchUser());
                    if (location.pathname !== '/') {
                        history.push(location.pathname + URLParams.querySearchParams());
                        return;
                    } else if (!R.isNil(user)) {
                        history.push(`/account`);
                    }
                }
            }
        }
        init();
        // eslint-disable-next-line
    }, []);


    if (account.isLoading.includes(Loadings.FETCHING_USER) ||
        (window.location.hash.startsWith("#id_token") && window.location.pathname === '/')
    ) {
        return <LoadingBall />;
    }
    if (R.isNil(account.user)) {
        return null;
    };


    return (
        <div id="app" className="theme gap-4">
            <h1 className="sr-only">Accounts securibox</h1>
            <Navbar />
            <main id="content" role="main" className="view">
                <h2 className="sr-only">View</h2>
                {/* <Cookies /> */}
                <Switch>
                    <Route path="/account" component={Account} />
                    <Route path="/services" component={Services} />

                    <Route render={() => {
                        let query = queryString.parse(location.hash.substring(1));
                        if (query.state !== undefined) {
                            return (<Redirect to={query.state} />);
                        }
                        if (account.user === undefined || R.isEmpty(account.user.apiUserPermission)) {
                            return (<Redirect to="/" />);
                        }
                        return <Redirect exact to="/account" />;
                    }} />
                </Switch>
            </main>
        </div>
    );
};


export default App;